import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Jem extends Product {
  @belongsTo('station-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'jem';
  label = 'JEM';
}

export default Jem;
